exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs.flex-column .nav-item.show .nav-link[data-v-19d1d5d5],.nav-tabs.flex-column .nav-link.active[data-v-19d1d5d5]{border-left:3px solid #17a2b8}.nav-item active[data-v-19d1d5d5]{background-color:#17a2b8}.list-group-item[data-v-19d1d5d5]{padding:2px 0}.profile-username[data-v-19d1d5d5]{font-size:20px;margin-top:5px}.nav-link[data-v-19d1d5d5]{font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19d1d5d5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/IndividualProfile.vue
// module id = 137
// module chunks = 0